import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { api } from "@/lib/api";

export const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll get back to you.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Failed to send. Try again.");
    }
    setLoading(false);
  };

  return (
    <section id="contact" className="py-24 sm:py-32 bg-[#0A0A0A] border-t border-[#2A2A2A]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="section-label mb-4">// REACH OUT //</p>
        <h2 className="font-anton text-4xl sm:text-5xl uppercase tracking-tight mb-6">
          Got <span className="neon-text">questions?</span>
        </h2>
        <p className="text-[#A1A1AA] text-sm mb-12">
          Hit us up — or email directly at <span className="text-[#39FF14] font-jet">aintdeady@gmail.com</span>
        </p>
        <form onSubmit={submit} className="card-ady p-8 sm:p-10 space-y-6">
          <div className="grid sm:grid-cols-2 gap-6">
            <input
              data-testid="contact-name-input"
              className="input-ady"
              placeholder="NAME"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
            <input
              data-testid="contact-email-input"
              type="email"
              className="input-ady"
              placeholder="EMAIL"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <textarea
            data-testid="contact-message-input"
            className="input-ady min-h-[140px] resize-y"
            placeholder="YOUR MESSAGE"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
          <button data-testid="contact-submit-btn" type="submit" disabled={loading} className="btn-brutal btn-brutal-green">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={16} />}
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};
